import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetFollowupEfficiencyReport } from "../services/reports.services";

const FollowupEfficiencyReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/followupefficiencyreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/followupefficiencyreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterUser = params?.filterUser;

  const loading = useAppSelector((state) => state.reports.loading);
  const FollowupEfficiencyListForReport = useAppSelector(
    (state) => state.reports.FollowupEfficiencyListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        UserID: filterUser !== "0" ? filterUser : 0,
      };
      dispatch(GetFollowupEfficiencyReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "FollowupEfficiencyReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "followupefficiencyreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Follow-Up Efficiency Report{" "}
          <span style={{ fontSize: 15 }}>
            {FollowupEfficiencyListForReport &&
              FollowupEfficiencyListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            FollowupEfficiencyListForReport &&
            FollowupEfficiencyListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            FollowupEfficiencyListForReport &&
            FollowupEfficiencyListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {FollowupEfficiencyListForReport &&
      FollowupEfficiencyListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  User Name
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Total Follow-up Assigned
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Completed On Time
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Missed / Overdue Follow-ups
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Follow-up Completion %
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Average Delay
                </th>
              </tr>
            </thead>
            <tbody>
              {FollowupEfficiencyListForReport &&
                FollowupEfficiencyListForReport.length > 0 &&
                FollowupEfficiencyListForReport?.map(
                  (FollowupEfficiency: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {FollowupEfficiency?.UserName || ""}
                      </td>
                      <td className="text-center">
                        {FollowupEfficiency?.TotalFollowupAssigned || ""}
                      </td>
                      <td className="text-center">
                        {FollowupEfficiency?.TotalCompletedOnTime || ""}
                      </td>
                      <td className="text-center">
                        {FollowupEfficiency?.MissedFollowups || ""}
                      </td>
                      <td className="text-center">
                        {FollowupEfficiency?.FollowupCompletionPercent || ""}
                      </td>
                      <td className="text-center">
                        {FollowupEfficiency?.AverageDelayDays || ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default FollowupEfficiencyReportView;
